// Re-export from shared location to avoid breaking existing imports.
export { PropValuesProvider, usePropValues } from "@/lib/contexts/PropValuesContext";
